export default __webpack_public_path__ + "static/media/a_wdt_c_0.48ad3b9b.mp3";